// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as IconButton from "../actions/IconButton.res.js";
import * as JsxRuntime from "react/jsx-runtime";

function Burger(props) {
  let onPress = props.onPress;
  return JsxRuntime.jsx(IconButton.make, {
    name: "burger",
    marginSize: "normal",
    color: "#535165",
    onPress: param => onPress()
  });
}

let make = React.memo(Burger);

export {
  make,
}
/* make Not a pure module */
